import { type PropsWithChildren } from "react";
import dayjs from "dayjs";
import * as Sentry from "@sentry/react";
import { IntlProvider } from "use-intl";
import { CacheProvider } from "./app/lib/context/CacheProvider";
import { MuiThemeProvider } from "./app/lib/context/MuiThemeProvider";
import { getDir } from "./app/lib/hooks/useLocaleInfo";
import {
  defaultLocale,
  isAllowedLocale,
  type Locale,
} from "./app/lib/utils/locale";
import { isProduction } from "./app/lib/constants";
import { platformApi } from "./app/lib/platform";
import api from "./app/lib/api/api";
import defaultMessages from "../messages/ar.json";

let locale: Locale = defaultLocale;
let messages = defaultMessages;

// TODO: modify this when we decide to support eng and ar versions on production
if (!isProduction) {
  try {
    const fetchedLocale = await platformApi.getLocale();

    locale = isAllowedLocale(fetchedLocale) ? fetchedLocale : defaultLocale;
    if (locale !== defaultLocale) {
      messages = (await import(`../messages/${locale}.json`)).default;
    }
  } catch (error) {
    Sentry.captureException(error);
  }
}

api.defaults.headers.common["Accept-Language"] = locale;
dayjs.locale(locale);
document.documentElement.dir = getDir(locale);

export const RouterWrapper = ({ children }: PropsWithChildren) => {
  return (
    <IntlProvider locale={locale} messages={messages}>
      <CacheProvider locale={locale}>
        <MuiThemeProvider>{children}</MuiThemeProvider>
      </CacheProvider>
    </IntlProvider>
  );
};
